// checkLivestreamChatPreflightAndOpenPanel.js
'use strict';
import getOperationData from '../selector/getOperationData.js';
import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import checkLivestreamChatPreflight from '../action/checkLivestreamChatPreflight.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';

/**
 * Check livestream chat preflight and set panel
 * @kind action
 * @param {string} {streamId} - action param.
 * @return {Promise} Action promise.
 */
const checkLivestreamChatPreflightAndOpenPanel =
  ({ streamId }) =>
  async (dispatch, getState) => {
    const selectPath = ['liveStream', streamId, 'chat', 'preflight'];
    const timestampOffsetSeconds = getTimestampOffset(
      getState(),
      Accuracy.SECOND
    );
    const now = getCurrentUnixTimestamp({
      offsetSeconds: timestampOffsetSeconds,
    });
    const exp = getOperationData(getState(), selectPath, 'exp');
    if (exp && exp > now)
      return dispatch(setLiveStreamPanel({ isChatPanelOpen: true }));

    await dispatch(checkLivestreamChatPreflight({ streamId }));

    const newExp = getOperationData(getState(), selectPath, 'exp') || 0;
    if (newExp > now)
      return dispatch(setLiveStreamPanel({ isChatPanelOpen: true }));
  };

export default checkLivestreamChatPreflightAndOpenPanel;
